import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../theme';

export const useMonitorFilterStyles = createStyles(({ token }) => ({
  stageFilterActiveLabel: {
    '.separator': {
      opacity: 0.5,
      margin: `0 ${ThemeSpaces.SPACE_SM}px`,
    },
  },
  dateRangeFilterClearButton: {
    color: token.colorPrimary,
    cursor: 'pointer',
    marginLeft: ThemeSpaces.SPACE_SM,
    fontSize: token.fontSize,
    display: 'flex',
    alignItems: 'center',

    '&:hover': {
      opacity: 0.7,
    },
  },
}));
